import { getMainDefinition } from 'apollo-utilities';
export const getIsSocket = ({ query }: any) => {
	const { kind, operation }: any = getMainDefinition(query);
	return kind === 'OperationDefinition' && operation === 'subscription';
};
